// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as PremiumPartnerRepoConfig from "./PremiumPartnerRepoConfig.bs.js";

function getURLParams(offset_ts) {
  var dict = {};
  dict["offset"] = Belt_Option.mapWithDefault(offset_ts, "-1", (function (prim) {
          return String(prim);
        }));
  dict["subscriber_type"] = "DRIVER_PARTNER";
  return dict;
}

function fetchSubscriptionReport(msisdn, offset, country) {
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/premium_subscription/" + (msisdn + "/crm_report"), getURLParams(offset));
  return CrmNetwork.get(requestUrl, "/premium_subscription/:msisdn/crm_report", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PremiumPartnerRepoConfig.PpResponseConverter.execute, result);
                        });
            });
}

var PremiumPartner = {
  fetchSubscriptionReport: fetchSubscriptionReport
};

export {
  PremiumPartner ,
  
}
/* Config Not a pure module */
